module.exports = __webpack_public_path__ + "static/img/brand_back_spa.e614195.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/brand_back_spa.png
// module id = kjNQ
// module chunks = 1